import { render, staticRenderFns } from "./HospitalDashboard.vue?vue&type=template&id=e67c3e74&scoped=true&"
import script from "./HospitalDashboard.vue?vue&type=script&lang=js&"
export * from "./HospitalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HospitalDashboard.vue?vue&type=style&index=0&id=e67c3e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67c3e74",
  null
  
)

export default component.exports